export default [
  {
    path: "/plantillasContrato",
    component: () => import("@/views/plantillasContrato/Listar.vue"),
  },
  {
    path: "/plantillasContrato/crear",
    component: () => import("@/views/plantillasContrato/Crear.vue"),
  },
  {
    path: "/plantillasContrato/editar/:id",
    component: () => import("@/views/plantillasContrato/Editar.vue"),
  },
];
